/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */

import React from "react";
import moment from "moment-timezone";
import { Row, Col, Card, OverlayTrigger, Tooltip, Image, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode, faCogs, faDownload, faRocket } from "@fortawesome/free-solid-svg-icons";
import BS5Logo from "../assets/img/technologies/bootstrap-5-logo.svg";
import ReactLogo from "../assets/img/technologies/react-logo.svg";
import GitHubButton from 'react-github-btn';
import { Link } from 'react-router-dom';
import { Routes } from "../routes";
import AppConfig from "../core/config/AppConfig";

export default (props) => {
  const currentYear = moment().get("year");
  const showSettings = props.showSettings;

  const toggleSettings = (toggle) => {
    props.toggleSettings(toggle);
  }

  return (
    <div style={{position: 'fixed',
      right: 0,
      bottom: 0,
      width: '200',
      height: 50,
    }}>      
      <footer className="float-end pe-5">
        <Row>
          <Col className="mb-4 mb-lg-0">
            <p className="mb-0 text-center text-xl-left">
              { AppConfig.dev_mode && <FontAwesomeIcon icon={faCode} color={'red'}/> }&nbsp;
              Copyright © {`${currentYear} `}
              <Card.Link href="https://joonaak.com" target="_blank" className="text-blue text-decoration-none fw-normal">
                Joonaak 
            </Card.Link>
            &nbsp;<small>(v.{AppConfig.appVersion})</small>
            </p>
          </Col>          
        </Row>
      </footer>
    </div>
  );
};
